import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentEmployeeRole, selectCurrentEmployeeType } from 'store/Employers';
import { selectCurrentUser } from 'store/User';
import { EmployeeRole } from 'types';
import { transformCurrentEmployeeRole } from 'utils/employers';

interface IPermissionGateProps {
  requiredRoles: EmployeeRole[];
  remoteSession?: boolean;
  children: React.ReactNode;
}

const PermissionGate: React.FC<IPermissionGateProps> = ({ requiredRoles, remoteSession = true, children }) => {
  const currentUser = useSelector(selectCurrentUser());
  const currentEmployeeType = useSelector(selectCurrentEmployeeType);
  const currentEmployeeRole = useSelector(selectCurrentEmployeeRole);

  // When remoteSession is set to false & the user is part of a remote session
  // Hide the component from being displayed
  if (!remoteSession && currentUser?.remoteSession) return <></>;

  if (requiredRoles.length === 0 || (currentEmployeeRole && requiredRoles.includes(transformCurrentEmployeeRole(currentEmployeeType, currentEmployeeRole)))) {
    return <>{children}</>;
  }

  return <></>;
};

export default PermissionGate;
